const getOpeningQty = (product, prevWeekBalance) => {
  return parseInt(prevWeekBalance.onHand.products[product.name] || 0, 10) +
  parseInt(prevWeekBalance.dispensed.products[product.name] || 0, 10)
}

module.exports = {
  getOpeningQty
}



// WEBPACK FOOTER //
// ./src/jobs/stock-level-tools.js